/* Component Dependencies */
var groupSearchSummaryTemplate = require('templates/groupSearchSummary.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'groupSearchSummary',

  subscribe: {
  	'SHOW_STICKY_GROUPS_SUMMARY': 'showGroupsSummary'
  },

  events: {
  	'click .t-groups-edit, #destination, #staydates, #guestrooms, #eventspace': 'showStickySearchForm'
  },

  template: {
    'groupSearchSummary': groupSearchSummaryTemplate
  },

  showStickySearchForm: function _showStickySearchForm(e) {
    e.preventDefault();
  	var focusElement = $(e.currentTarget).data('focus');
    this.$el.addClass('is-hidden');
    this.pubsub.publish('SHOW_GROUPS_SEARCH_FORM', [focusElement]);
	},

	showGroupsSummary: function _showGroupsSummary() {
		this.$el.removeClass('is-hidden');
	}
});
